import {axiosGet, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        const getTranslate = (row, key) => {
            const locate = window?.appLanguage.toLowerCase()

            if (!row[key]) {
                return ''
            }

            if (row[key][locate] && row[key][locate] !== '') {
                return row[key][locate]
            }

            return row[key]['ja'] || ''
        }

        return {
            urlGenerator,
            options: {
                name             : this.$t('jobs'),
                url              : `${TENANT_BASE_URL}app/work-place`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('title'),
                        type     : 'custom-html',
                        key      : 'title',
                        isVisible: true,
                        modifier : (value, row) => getTranslate(row, 'title')
                    },
                    {
                        title    : this.$t('salary'),
                        type     : 'custom-html',
                        key      : 'salary',
                        isVisible: true,
                        modifier : (value, row) => getTranslate(row, 'salary')
                    },
                    {
                        title    : this.$t('place'),
                        type     : 'custom-html',
                        key      : 'place',
                        isVisible: true,
                        modifier : (value, row) => getTranslate(row, 'place')
                    },
                    {
                        title    : this.$t('station'),
                        type     : 'custom-html',
                        key      : 'station',
                        isVisible: true,
                        modifier : (value, row) => getTranslate(row, 'station')
                    },
                    {
                        title    : this.$t('status'),
                        type     : 'custom-html',
                        key      : 'status',
                        isVisible: true,
                        modifier : (value) => {
                            let result = '';
                            if (value === 'open') {
                                result = '<div class="tag-item badge badge-pill badge-success">' + this.$t('job_open') + '</div>';
                            } else if (value === 'close') {
                                result = '<div class="tag-item badge badge-pill badge-danger">' + this.$t('job_close') + '</div>';
                            }
                            return result;
                        }
                    },
                    {
                        title    : this.$t('department'),
                        type     : 'custom-html',
                        key      : 'created_by',
                        isVisible: true,
                        modifier : (value, row) => value && value.department ? value.department.name : ''
                    },
                    {
                        title    : this.$t('user'),
                        type     : 'custom-html',
                        key      : 'created_by',
                        isVisible: true,
                        modifier : (value, row) => value && value.full_name ? value.full_name : ''
                    },
                    {
                        title    : this.$t('applicant'),
                        type     : 'custom-html',
                        key      : 'candidates_count',
                        isVisible: true,
                        modifier : (value, row) => {
                            return '<a href="/candidate?work_place_id=' + row.id + '">' + value + ' '  + this.$t('apply') + '</a>';
                        }
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('tags'),
                        type          : "multi-select-filter",
                        key           : "tag_id",
                        option        : [],
                        listValueField: 'title',
                        permission    : !!this.$can('view_interview_tag')
                    },
                    {
                        title         : this.$t('status'),
                        type          : "multi-select-filter",
                        key           : "status",
                        option        : [
                            {id: 'open', name: this.$t('job_open')},
                            {id: 'close', name: this.$t('job_close')},
                        ],
                        listValueField: 'name',
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'dropdown',
                actions          : [
                    {
                        title   : this.$t('copy'),
                        icon    : 'copy',
                        type    : 'modal',
                        modifier: row => this.$can('view_work_place')
                    },
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_work_place')
                    },
                    {
                        title   : this.$t('translate'),
                        icon    : 'globe',
                        modifier: row => this.$can('update_work_place')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/work-place`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_work_place')
                    }
                ],
            }
        }
    },
    mounted() {
        this.getFilterOptions();
    },
    methods: {
        getFilterOptions() {
            const Error     = error => this.$toastr.e(error.response.data.message)
            const tagFilter = this.options.filters.find(item => item.key === 'tag_id');

            axiosGet(`${TENANT_BASE_URL}app/interview-tag?per_page=0&type=0,1`).then(({data}) => tagFilter.option = data).catch(Error)
        },
    },
}
